import { render, staticRenderFns } from "./BudgetOverview.vue?vue&type=template&id=7eafcfe7"
import script from "./BudgetOverview.vue?vue&type=script&lang=js"
export * from "./BudgetOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports